import {Component, OnInit} from '@angular/core';
import {ButtonDirective} from "primeng/button";
import {InputTextModule} from "primeng/inputtext";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SvgLoaderComponent} from "lib-base";
import {AsyncPipe, NgClass} from "@angular/common";
import {Router, RouterLink} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {firstValueFrom, forkJoin, map, Observable} from "rxjs";
import {TipoPqrsdfService} from "../../../../services/pqrsd/tipo-pqrsdf.service";
import {ITipoSolicitudesDisponiblesPQRSDF} from "../../../../shared/interfaces/pqrsdf";
import {SkeletonModule} from "primeng/skeleton";
import {MessageService} from "primeng/api";
import {FooterComponent} from "../../../../components/template/footer/footer.component";

@Component({
  selector: 'app-pqrsdf-landing',
  standalone: true,
  imports: [
    ButtonDirective,
    InputTextModule,
    ReactiveFormsModule,
    SvgLoaderComponent,
    NgClass,
    RouterLink,
    FormsModule,
    AsyncPipe,
    SkeletonModule,
    FooterComponent
  ],
  templateUrl: './pqrsdf-landing.component.html',
  styleUrl: './pqrsdf-landing.component.scss'
})
export class PqrsdfLandingComponent implements OnInit {

  cards$: Observable<any[]>;
  translations: any = {};
  radicado: string = '';
  private readonly routeIcons: string = 'assets/img/icons-principal';
  classContainers: string[] = [];
  constructor(private translateService: TranslateService,
              private router: Router,
              private _ms: MessageService,
              private tipoSolicitudService: TipoPqrsdfService) {
    this.initClassContainers();
    this.cards$ = this.getTiposSolicitudes();
  }

  async ngOnInit() {
    await this.getTraslations();
  }

  private async getTraslations(): Promise<void> {
    this.translations = await firstValueFrom(forkJoin({
      header: this.translateService.get('components.app-pqrsd.header'),
      subHeader: this.translateService.get('components.app-pqrsd.sub-header'),
      titleSeguimiento: this.translateService.get('components.app-pqrsd.title-seguimiento-pqrsd'),
      tituloTipos: this.translateService.get('components.app-pqrsd.titulo-tipos'),
      plazoNormal: this.translateService.get('components.app-pqrsd.plazo-normal'),
      placeholderRadicado: this.translateService.get('components.app-pqrsd.placeholder-radicado'),
      btnVer: this.translateService.get('form.button.ver'),
      warnSummary: this.translateService.get('form.msg.warn-summary'),
      completeCampos: this.translateService.get('form.msg.complete-campos'),
    }));
  }

  initCards(data: Required<ITipoSolicitudesDisponiblesPQRSDF>[]): any[] {
    return data.map((item, index) =>
      ({
        classContainer: this.getClassContainersByIndex(index),
        title: item.nombre,
        tag: (this.translations.plazoNormal as string)?.replace('%d', item.plazo + ''),
        description: item.descripcion, img: `${this.routeIcons}/${item.icono}`,
        alt: item.nombre, link: '/public/formulario-pqrsd/' + item.nombre
      } as any));
  }

  initClassContainers() {
    this.classContainers = [
      'md:col-5 lg:col-3 lg:mr-6 lg:mb-3 md:mr-4',
      'md:col-5 lg:col-3 lg:mx-6 lg:mb-3 md:ml-6',
      'md:col-5  md:ml-0 md:mr-4 mt-3 lg:mt-0 lg:mr-0 lg:col-4 xl:ml-6 lg:mb-3',
      'md:col-5 lg:col-3 lg:mr-6 md:ml-6 lg:ml-0 mt-3  ',
      'md:col-5 lg:col-3 lg:mt-3 mt-3 lg:mx-6 md:ml-0 md:mr-4',
      'md:col-5 lg:col-4 lg:mt-3 mt-3 lg:ml-6 md:ml-6',
    ];
  }

  getClassContainersByIndex(index: number): string {
    return this.classContainers[index] ?? this.classContainers[0];
  }

  getTiposSolicitudes() : Observable<any[]> {
   return this.tipoSolicitudService
      .getSolicitudesDisponibles()
      .pipe(map((items) => this.initCards(items)));
  }

  buscar(){
    if (!this.radicado) {
      this._ms.add({ severity: 'warn', summary: this.translations.warnSummary, detail: this.translations.completeCampos });
      return;
    }
    this.router.navigateByUrl(`public/estado-pqrsdf/${this.radicado}`).then();
  }
}
